module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Regular-f0055f773fa996ef53850bbe295d9f4d.eot";